import ErrorFeedBack from './ErrorFeedBack.component';

export default ErrorFeedBack;
